import React from 'react';
import {DesktopPage} from '../../../clean-components/desktop-page/desktop-page';
import {LineDetailComponent} from '../../../clean-components/line-detail/line-detail.component';

export const LineDetailDesktop = () => {
    return <DesktopPage>
        <LineDetailComponent buttons={['report']}/>
    </DesktopPage>;
};
